























































import newButton from '@/components/Reusable/NewButton.vue';
import discount from '@/store/types/discount';
import DatesFormat from '@/util/classes/datesFormat';
import SweetAlert from '@/util/classes/SweetAlert';
import { TeipNotifications } from '@/util/teipNotifications';
import { DiscountParams } from '@/store/interfaces/discount';
import { allowAny, tPropsToSearch, tTableColumns } from 'teip-components';
import { TableRef } from '@/store/interfaces/generic';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'DiscountsHome',
  components: {
    newButton,
  },
  data: () => ({
    viewDetails: false,
    propsToSearch: [] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'name',
        label: 'Nombre',
        minWidth: 250,
        sortable: true,
      },
      {
        prop: 'discount_type',
        label: 'Alcance',
        minWidth: 250,
        sortable: true,
        formatter: (row: DiscountParams): string => {
          const discountTypes = {
            regular: 'Todos',
            sign_up: 'Solo primera transacción',
          };
          return discountTypes[row.discount_type] ?? 'Desconocido';
        },
      },
      {
        prop: 'start_at',
        label: 'Fecha de inicio',
        minWidth: 150,
        sortable: true,
        formatter: (row: DiscountParams): string => {
          return `${formatDate.formatDateTime(row.start_at)}`;
        },
      },
      {
        prop: 'end_at',
        label: 'Fecha Fin',
        minWidth: 150,
        sortable: true,
        formatter: (row: DiscountParams): string => {
          return `${formatDate.formatDateTime(row.end_at)}`;
        },
      }
    ] as tTableColumns,
    rowSelected: {
      id: '',
      name: '',
      description: '',
      kind: 'individual',
      bonus: 'percentage',
      network: 'all',
      participation: 'commerce',
      discount_type: 'regular',
      cap: 'all',
      amount_cents: 0,
      amount_currency: 'USD',
      budget_cents: 0,
      budget_currency: 'USD',
      transactions_count: 0,
      platform_participation_percentage: 0,
      commerce_participation_percentage: 0,
      occurrences_count: 0,
      percentage: 0,
      user_occurrences_count: 1,
      start_at: '',
      end_at: '',
      minimum_amount_cents: 0,
      minimum_amount_currency: 'USD',
      maximum_amount_cents: 0,
      maximum_amount_currency: 'USD',
      transaction_amount_cents: 0,
      transaction_amount_currency: 'USD',
      ceiling_amount_cents: 0,
      ceiling_amount_currency: 'USD',
      range_minimum_amount_cents: 0,
      range_minimum_amount_currency: 'USD',
      range_maximum_amount_cents: 0,
      range_maximum_amount_currency: 'USD',
      average_amount_cents: 0,
      average_amount_currency: 'USD',
      rules: [],
    } as DiscountParams,
    showevent: false,
  }),
  computed: {
    ...mapGetters({
      getDiscountList: `discount/${discount.getters.GET_DISCOUNTS}`,
    }),
  },
  methods: {
    ...mapActions({
      DiscountList: `discount/${discount.actions.DISCOUNT_LIST}`,
      deletedDiscount: `discount/${discount.actions.DELETE_DISCOUNT}`,
    }),
    rowselect(row: { id: string }): void {
      this.$data.rowSelected = row;
    },
    viewDetailsAction(): void {
      this.$router.push({
        name: 'NoveltiesDiscountEdit',
        params: { discount_id: this.rowSelected.id, },
      } as allowAny);
    },
    async deleteAction(): Promise<void> {
      const notification = new TeipNotifications();
      const swal = new SweetAlert();
      swal
        .askingSweetAlert({
          title: 'Eliminar Descuento',
          text: '¿Seguro que desea eliminar el descuento?',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Sí, eliminar',
          alertType: 'warning',
        })
        .then((res) => {
          res &&
            this.deletedDiscount(this.$data.rowSelected)
              .then(() => {
                notification.success('Descuento Eliminado');
                (this.$refs.refDiscountList as TableRef).fetchData();
              })
              .catch(() => {
                notification.warning('Ha ocurrido un error al eliminar :(');
              });
        });
    },
  },
});
